import HTTP from './http'
import ParamUtils from './utils/param'
import ModalUtils from './utils/modal'

//组件
import WebBaseModal from './components/base-modal'

const components = {
    WebBaseModal
}

const install = function(Vue, opts = {}) {
    if (install.installed) {
        return;
    }

    Object.keys(components).forEach(key => {
        Vue.component(key, components[key]);
    });
}

const API = {
    install,
    HTTP,
    ParamUtils,
    ModalUtils
}

export default API;